import { Wifi, Monitor, Armchair, TreePine, Users, House } from 'lucide-react'
import { useLanguage } from '../context/LanguageContext'
import { sectionImages } from '../data/imageBank'

export default function Gites() {
  const { t } = useLanguage()
  const features = [
    { icon: <Wifi className="w-4 h-4 text-ng-mid" />, label: t('gites.feature1') },
    { icon: <Monitor className="w-4 h-4 text-ng-mid" />, label: t('gites.feature2') },
    { icon: <Armchair className="w-4 h-4 text-ng-mid" />, label: t('gites.feature3') },
    { icon: <TreePine className="w-4 h-4 text-ng-mid" />, label: t('gites.feature4') },
    { icon: <Users className="w-4 h-4 text-ng-mid" />, label: t('gites.feature5') },
    { icon: <House className="w-4 h-4 text-ng-mid" />, label: t('gites.feature6') },
  ]
  const types = [t('gites.type1'), t('gites.type2'), t('gites.type3'), t('gites.type4')]

  return (
    <section id="gites" className="py-20 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">

          {/* Image */}
          <div className="relative order-2 lg:order-1">
            <img
              src={sectionImages.gites}
              alt={t('gites.imageAlt')}
              className="rounded-2xl shadow-xl w-full h-[500px] object-cover"
              loading="lazy"
              decoding="async"
              onError={(e) => {
                e.target.parentElement.querySelector('.img-fallback').style.display = 'flex'
                e.target.style.display = 'none'
              }}
            />
            <div
              className="img-fallback rounded-2xl shadow-xl w-full h-[500px] items-center justify-center hidden"
            >
              <span className="text-ng-dark/30 text-sm">gite-interior.jpg</span>
            </div>
            <div className="absolute -bottom-6 -right-6 bg-ng-dark rounded-xl p-6 shadow-lg">
              <div className="font-display text-3xl font-bold text-white">20+</div>
              <div className="text-sm text-white/80">{t('gites.capacity')}</div>
            </div>
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2">
            <span className="text-sm font-medium text-ng-brown uppercase tracking-wider">{t('gites.kicker')}</span>
            <h2 className="font-display text-4xl lg:text-5xl text-ng-dark mt-3 mb-6 font-bold">
              {t('gites.title')}
            </h2>
            <p className="text-lg text-ng-dark/85 leading-relaxed mb-8">
              {t('gites.intro')}
            </p>

            {/* Characteristics */}
            <div className="mb-10">
              <h3 className="font-display text-xl text-ng-dark mb-4 font-semibold">{t('gites.featuresTitle')}</h3>
              <div className="grid sm:grid-cols-2 gap-3">
                {features.map(({ icon, label }) => (
                  <div key={label} className="flex items-center gap-3 text-ng-dark/85">
                    <div className="w-8 h-8 rounded-lg bg-ng-mid/10 flex items-center justify-center flex-shrink-0">
                      {icon}
                    </div>
                    <span className="text-sm">{label}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Types */}
            <div>
              <h3 className="font-display text-xl text-ng-dark mb-4 font-semibold">{t('gites.typesTitle')}</h3>
              <div className="flex flex-wrap gap-2">
                {types.map((t) => (
                  <span key={t} className="px-4 py-2 bg-ng-beige border border-ng-dark/10 rounded-full text-sm text-ng-dark">
                    {t}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
